import constant from "../../constant";

const resource = constant.api + "orders";

const state = {
  loadOrders: [],
  loadOrder: null,
};

const getters = {
  getAll: (state) => state.loadOrders,
  getCurrent: (state) => state.loadOrder,
};

const actions = {
  async getAll({ commit }, params = {}) {
    const response = await this.$api.create(`${resource}_my`, params, {
      confirm: false,
    });
    const data = Array.isArray(response) ? response : response?.data || [];
    commit("setAll", data);
    return data;
  },
  async show({ commit }, reference) {
    if (!reference) return null;
    const response = await this.$api.show(`${resource}/${reference}`);
    const data = response?.data || response || null;
    commit("setCurrent", data);
    return data;
  },
  async store({ dispatch }, payload) {
    const response = await this.$api.create(resource, payload, {
      confirm: false,
    });
    await dispatch("getAll");
    return response?.data || response;
  },
  async update({ dispatch }, { reference, data }) {
    if (!reference) {
      throw new Error("Missing load order reference for update");
    }
    const response = await this.$api.update(`${resource}/${reference}`, data, {
      confirm: true,
    });
    await dispatch("getAll");
    return response?.data || response;
  },
  async destroy({ dispatch }, reference) {
    if (!reference) return null;
    const response = await this.$api.delete(`${resource}/${reference}`, {
      confirm: true,
    });
    await dispatch("getAll");
    return response?.data || response;
  },
  resetCurrent({ commit }) {
    commit("setCurrent", null);
  },
};

const mutations = {
  setAll(state, data) {
    state.loadOrders = Array.isArray(data) ? data : [];
  },
  setCurrent(state, data) {
    state.loadOrder = data || null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
